module.exports = ".card__title {\n  margin-bottom: 20px;\n}\n\n.margin-bottom {\n  margin-bottom: 15px;\n}\n\n.edit-mode-active {\n  border-bottom: 3px solid lightblue !important;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main-settings/cfo-pin/cfo-pin.component.css
// module id = ./src/app/main-settings/cfo-pin/cfo-pin.component.css
// module chunks = main